import * as actions from "../actions/PageActions";
import { PageState, initialState } from "../store/PageState";
import buildReducer from "../utils/ReducerBuilder";
import { PageStateStatus, Page } from "../models/page";
import { List } from "immutable";

export const PageReducer = buildReducer<PageState>(initialState)
    .handle(actions.onPageLoaded, (state, action) => {
        if (!action.payload)
            return { ...state };

        let pages = List<Page>();
        let statuses = List<PageStateStatus>();
        const newStatus: PageStateStatus = {
            errors: [],
            id: action.payload.id,
            loading: false,
            found: true,
        };

        let idx = state.statuses.findIndex((x) => x !== undefined && action.payload !== undefined && x.id === action.payload.id);
        if (idx === -1)
            statuses = state.statuses.push(newStatus);
        else
            statuses = state.statuses.set(idx, newStatus);

        idx = state.pages.findIndex((x) => x !== undefined && action.payload !== undefined && x.id === action.payload.id);
        if (idx === -1)
            pages = state.pages.push(action.payload);
        else
            pages = state.pages.set(idx, action.payload);

        return {
            ...state,
            pages,
            statuses,
        };
    })
    .handle(actions.onPageSubscribed, (state, action) => {
        if (!action.payload)
            return { ...state };

        let subscribedIds = List<number>();
        const idx = state.subscribedIds.findIndex((x) => x !== undefined && x === action.payload);
        if (idx === -1)
            subscribedIds = subscribedIds.push(action.payload);
        else
            subscribedIds = state.subscribedIds.set(idx, action.payload);

        console.log("page subscription updated", subscribedIds.toArray());

        return {
            ...state,
            subscribedIds,
        };
    })
    .handle(actions.onPageStatusUpdate, (state, action) => {
        if (!action.payload)
            return { ...state };

        let statuses = List<PageStateStatus>();
        const idx = state.statuses.findIndex((x) => x !== undefined && action.payload !== undefined && x.id === action.payload.id);
        if (idx === -1)
            statuses = state.statuses.push(action.payload);
        else
            statuses = state.statuses.set(idx, action.payload);

        console.log("page status updated", action.payload);

        return {
            ...state,
            statuses,
        };
    })
    .done();



// WEBPACK FOOTER //
// ./src/reducers/PageReducer.ts